import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials makes the browser send + accept the httpOnly `access_token` cookie
// issued by /api/auth/login and /api/auth/register.
export const api = axios.create({ baseURL: API, withCredentials: true });
